import React, { Component } from 'react';

import classes from './BookingPolicies.css';
import SquaredCheckbox from '../UI/Checkbox/SquaredCheckbox/SquaredCheckbox';
import { CenterContainer } from '../CenterContainer/CenterContainer';
import Modal from '../../components/UI/Modal/Modal';
import Button from "../../components/UI/Button/Button";

class BookingPolicies extends Component {
  texts = {
    terms_and_privacy: (
      <React.Fragment>
        {this.props.translations.label_privacy_booking_first}
        <a className={classes.PrivacyPolicyLink} href="https://www.temakinho.com/pages/informativa-privacy-per-il-servizio-book-a-table" target="_blank" rel="noopener noreferrer">
          {this.props.translations.label_privacy_booking_policy}
        </a>
        {this.props.translations.label_terms_condition_booking_first}
        <a className={classes.PrivacyPolicyLink} href="https://www.temakinho.com/pages/termini-e-condizioni-book-a-table" target="_blank" rel="noopener noreferrer">
          {this.props.translations.label_terms_condition_booking_terms_and_conditions}
        </a>
        {this.props.translations.label_privacy_booking_last}
      </React.Fragment>
    ),
  }

  restaurantData = {
    text: this.props.termsAndPolic
  }

  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: props.showPopup
    }
  }

  render() {
    return (
      <CenterContainer>
        <Modal
          show={this.state.isModalOpen}
          modalClosed={() => this.setState({ isModalOpen: false })}
          isFitToContent={false}
          dismissable={false}
          isFullScreen={false}
          isFullScreenNarrow={true}
          closeIconCallback={this.props.goBack}
        >
          {this.props.storePopup && <div className={classes.ModalContentContainer}>
            <p className={classes.ModalTitle}>{this.props.storePopup.primaryTitle}</p>
            <p className={classes.ModalText}>{this.props.storePopup.primaryMessage}</p>
            <Button
              btnLabel={this.props.storePopup.primaryButton}
              clicked={() => {
                this.setState({ isModalOpen: false })
              }}
            />
          </div>}
        </Modal>
        <div>
          <div className={classes.ImageContainer}>
            <img src={this.props.logo} className={classes.Image} />
          </div>
          <div>
            <p className={classes.RestaurantName}>{this.props.storeName}</p>
            <p className={classes.RestaurantDescription} dangerouslySetInnerHTML={{ __html: this.props.termsAndPolic }}></p>
          </div>
          <div className={classes.BookingPolicies_interactions}>
            <SquaredCheckbox label={this.texts.terms_and_privacy} clicked={this.props.onToggleTermsAndPrivacy} isChecked={this.props.hasAcceptedTermsAndPrivacy} />
            </div>
        </div>
      </CenterContainer>
    );
  }
}

export default BookingPolicies;


// WEBPACK FOOTER //
// ./src/components/bookingPolicies/BookingPolicies.js